import { DataModel } from "@toolpad/core/Crud";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

import { IBatteryDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import { identityService } from "../services/identity.service";
import { AppClient } from "../services/client.service";
import { axiosInstance } from "../core/axios-interceptors";
import { getBaseUrl } from "../core/config";

type BatteryDataModel = IBatteryDto & DataModel;

export default function BatteriesPage() {
  const columns: MagicCrudFields<IBatteryDto>[] = [
    {
      field: nameof<IBatteryDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IBatteryDto>("bcuUid"),
      type: "string",
      isRequired: true,
    },
    {
      field: nameof<IBatteryDto>("serialNumber"),
      type: "string",
    },
    {
      field: nameof<IBatteryDto>("stateOfCharge"),
      type: "number",
    },
    {
      field: nameof<IBatteryDto>("userId"),
      type: "string",
      extraType: "guid",
      editable: false,
      notInShowMode: identityService.checkEndpointsAllowed("users", "GET"),
    },
    {
      field: "user",
      type: "string",
      extraType: "guid",
      editable: false,
      getValueToShow: async (d) => {
        if (!d.userId) {
          return "";
        }
        const r = await axiosInstance.get(
          `${getBaseUrl()}/users/app?$top=1&$skip=0&$filter=id%20eq%20${d.userId}&$count=true`,
        );
        const user = r.data?.value?.[0];
        return user?.name ? `${user?.name} ${user?.lastName}` : user?.email;
      },
      notInGridMode: true,
      notInShowMode: !identityService.checkEndpointsAllowed("users", "GET"),
    },
    {
      field: nameof<IBatteryDto>("vehicleId"),
      type: "string",
      extraType: "guid",
      editable: false,
      notInShowMode: identityService.checkEndpointsAllowed("vehicles", "GET"),
    },
    {
      field: "vehicle",
      type: "string",
      extraType: "guid",
      editable: false,
      getValueToShow: async (d) => {
        if (!d.vehicleId) {
          return "";
        }
        var veicleDto = await AppClient.getInstance().vehiclesGET2(
          d.vehicleId!,
          AppClient.version,
        );
        return (veicleDto as any)?.serialNumber;
      },
      notInGridMode: true,
      notInShowMode: !identityService.checkEndpointsAllowed("vehicles", "GET"),
    },
    {
      field: nameof<IBatteryDto>("groupId"),
      type: "string",
      extraType: "guid",
      notInShowMode: identityService.checkEndpointsAllowed("groups", "GET"),
      notInCreateMode: true,
    },
    {
      field: "group",
      type: "string",
      extraType: "guid",
      editable: false,
      getValueToShow: async (d) => {
        if (!d.groupId) {
          return "";
        }
        const r = await axiosInstance.get(
          `${getBaseUrl()}/groups?$top=1&$skip=0&$filter=id%20eq%20${d.groupId}&$count=true`,
        );
        return r.data?.value?.[0]?.name ?? "";
      },
      notInGridMode: true,
      notInShowMode: !identityService.checkEndpointsAllowed("groups", "GET"),
    },
    {
      field: nameof<IBatteryDto>("batteryStationId"),
      type: "string",
      extraType: "guid",
      notInGridMode: true,
    },
    {
      field: nameof<IBatteryDto>("fwVersion"),
      type: "string",
    },
    {
      field: nameof<IBatteryDto>("updateDate"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<BatteryDataModel>
      name="battery"
      apiUrl="batteries"
      columns={columns}
      appUrl="/batteries"
    />
  );
}
